// Enum for Status (matches contract Status enum exactly)
export var TokenStatus;
(function (TokenStatus) {
    TokenStatus[TokenStatus["Uninitialized"] = 0] = "Uninitialized";
    TokenStatus[TokenStatus["Bonding"] = 1] = "Bonding";
    TokenStatus[TokenStatus["Dex"] = 2] = "Dex";
})(TokenStatus || (TokenStatus = {}));
